module.exports = __webpack_public_path__ + "static/assets/65af98bbf58e0299b2955efdda03dcd1.svg";